// extracted by mini-css-extract-plugin
module.exports = {"uploadBtnStyle":"SelectWithActionBtn_uploadBtnStyle__8+hDk"};